import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
export var LeaguePrizesAlreadyPurchased = function () {
    return React.createElement(Icon, { icon: IdIcon.StampGfx, styleId: IdStyles.IconExtraLarge });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeaguePrizesAlreadyPurchased.tsx
// module id = 2792
// module chunks = 3